var React = require('react');

function StepCircle0660px (props) {
    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M30 58c15.464 0 28-12.536 28-28S45.464 2 30 2 2 14.536 2 30s12.536 28 28 28zm0 2c16.569 0 30-13.431 30-30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30zm5.256-41.796v1.584c-.684 0-1.548.036-2.52.252-5.04 1.044-7.92 5.364-8.388 9.972h.072c1.08-1.728 3.204-3.276 6.048-3.276 4.284 0 6.984 3.168 6.984 7.524 0 4.068-2.556 8.136-7.308 8.136-4.212 0-7.596-3.42-7.596-9.828 0-4.716 1.656-8.352 3.816-10.62 1.692-1.764 4.032-2.988 6.552-3.456a10.049 10.049 0 0 1 2.34-.288zm-5.004 22.752h.036c3.168 0 5.364-2.592 5.364-6.552 0-4.104-2.376-6.192-5.616-6.192-2.196 0-4.284 1.332-5.364 3.384-.216.396-.396.864-.396 1.368 0 4.716 2.124 7.992 5.976 7.992z"}));
}

StepCircle0660px.displayName = "StepCircle0660px";

StepCircle0660px.defaultProps = {"viewBox":"0 0 60 60"};

module.exports = StepCircle0660px;

StepCircle0660px.default = StepCircle0660px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/60px/step-circle-06-60px.svg
// module id = 1211
// module chunks = 0